import { isUndefined } from "lodash";
import { createElement, FunctionComponent, useMemo } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Some } from "space-monad";
import styled from "styled-components";
import { Select } from "../../../../../components/forms/select";
import { Grid } from "../../../../../components/layout";
import { useFetchable } from "../../../../../store/common/fetchable";
import {
  defaultFieldNames,
  useDefaultFieldConfigMap,
  useDefaultFieldMap,
  useDefaultFieldNames,
} from "../../../../../store/launch-configurations/models/default-fields";
import { Field } from "../../../../../store/launch-configurations/models/internal/field";
import { Verification } from "../../../../../store/verification/reducer";
import { useNewLaunchContext } from "../../context";

interface IDefaultFieldsProps {}

const StyledGrid = styled(Grid)`
  min-width: 20em;
`;

const DefaultFields: FunctionComponent<IDefaultFieldsProps> = () => {
  const currentMerchantConfig = useFetchable(
    Verification.currentMerchantConfig
  );
  const { control, watch } = useFormContext<Field.DefaultField>();
  const { isCrypto } = useNewLaunchContext();

  const fieldTypeNames = useDefaultFieldNames();
  const defaultFieldMap = useDefaultFieldMap();

  const configs = useDefaultFieldConfigMap();

  const availableOptions = useMemo(
    () =>
      Some(defaultFieldNames)
        .map((x) =>
          !isCrypto ? x.filter((k) => !defaultFieldMap[k].cryptoField) : x
        )
        .map((x) =>
          currentMerchantConfig.status === "ready"
            ? x.filter((y) => {
                const foo = defaultFieldMap[y].service;
                return (
                  isUndefined(foo) ||
                  currentMerchantConfig.data.includedServices.includes(foo)
                );
              })
            : x
        )
        .getOrElse([]),
    [defaultFieldNames, isCrypto, defaultFieldMap, currentMerchantConfig]
  );

  const field = watch("field");

  const configElem = useMemo(() => field && configs[field], [field, configs]);

  return (
    <div style={{ padding: "2em" }}>
      <StyledGrid col-xs={2}>
        <strong>Field</strong>
        <Controller
          control={control}
          name="field"
          render={({ field, fieldState: { error } }) => (
            <Select
              {...field}
              helperText={error?.message}
              error={!!error}
              options={availableOptions.map((x) => ({
                title: fieldTypeNames[x],
                value: x,
              }))}
            />
          )}
        />
      </StyledGrid>
      {configElem ? createElement(configElem.elem) : null}
    </div>
  );
};

export default DefaultFields;
